module.exports = __webpack_public_path__ + "img/bottom2.c475baf5.png";